import { useMutation, useQuery } from 'react-query';
import queryGetPlans from './queries/getPlans';
import queryGetParentPlans from './queries/getParentPlans';
import queryGetPlan from './queries/getPlan';
import queryGetAllowedClients from './queries/getAllowedClients';
import mutationDeleteAllowedClient from './mutations/deleteAllowedClient';
import mutationAddAllowedClients from './mutations/addAllowedClients';
import mutationUpdatePlan from './mutations/updatePlan';
import mutationCreatePlan from './mutations/createPlan';

const actionsPlans = {
  // get one plan
  getPlan: (params, enabled = true) => useQuery(queryGetPlan(params, enabled)),
  // get all plans
  getPlans: (params, enabled) => useQuery(queryGetPlans(params, enabled)),
  // get parent plans
  getParentPlans: (params, enabled) => useQuery(queryGetParentPlans(params, enabled)),
  // get allowed clients
  getAllowedClients: (params, enabled) => useQuery(queryGetAllowedClients(params, enabled)),
  // delete allowedClient
  deleteAllowedClient: (onSuccess, onError) => useMutation(mutationDeleteAllowedClient(onSuccess, onError)),
  // add allowed clients
  addAllowedClients: (onSuccess, onError) => useMutation(mutationAddAllowedClients(onSuccess, onError)),
  // create plan
  createPlan: (onSuccess, onError) => useMutation(mutationCreatePlan(onSuccess, onError)),
  // update plan
  updatePlan: (onSuccess, onError) => useMutation(mutationUpdatePlan(onSuccess, onError))
};

export default actionsPlans;